import React from 'react';
import IAppRoute from './AppRoute.type';
import routepaths from './routepaths';
import Maintenance from '../pages/Maintenance';
import Gemini from '../pages/Gemini';
import UserAndRoles from '../pages/UserAndRoles';
import RoleAndPermissions from '../pages/RoleAndPermissions';
import Nominations from '../pages/Nominations';
import Trading from '../pages/Trading';
import Audit from '../pages/Audit';
import Dashboard from '../pages/Dashboard';
import SenseCheck from '../pages/SenseCheck';
import Cva from '../pages/Cva';
import SummaryReports from '../pages/SummaryReports';

const GenesisRoutes: IAppRoute[] = [
  { path: routepaths.dashboard, element: <Dashboard /> },
  { path: routepaths.activity, element: <Maintenance /> },
  { path: routepaths.maintenance, element: <Maintenance /> },
  { path: routepaths.locations, element: <Maintenance /> },
  { path: routepaths.gemini, element: <Gemini /> },
  { path: routepaths.userAndRoles, element: <UserAndRoles /> },
  { path: routepaths.addRoleAndPermissions, element: <RoleAndPermissions /> },
  {
    path: routepaths.modifyRoleAndPermissions,
    element: <RoleAndPermissions />,
  },
  { path: routepaths.nominations, element: <Nominations /> },
  { path: routepaths.nominationsHistory, element: <Nominations /> },
  { path: routepaths.trade, element: <Trading /> },
  { path: routepaths.audit, element: <Audit /> },
  { path: routepaths.senseCheck, element: <SenseCheck /> },
  { path: routepaths.cva, element: <Cva /> },
  { path: routepaths.summaryReports, element: <SummaryReports /> },
];

export default GenesisRoutes;
